import { combineReducers } from 'redux'

import accountsPayable from './accountsPayable'
import auth from './auth'
import balanceSheet from './balanceSheet'
import calculations from './calculations'
import cashAlert from './cashAlert'
// cashFlow now lives in store/calculations (modernized pattern)
import employees from './employees'
import otherCosts from './otherCosts'
import decisionAids from './decisionAids'
import graphics from './graphics'
import incomeStatements from './incomeStatements'
import intangibleAssets from './intangibleAssets'
import user from './user'
import loans from './loans'
import marketingBoard from './marketingBoard'
import marketRound from './marketRound'
import marketForecast from './marketForecast'
import marketStrategy from './marketStrategy'
import orders from './orders'
import procurement from './procurement'
import productDevelopment from './productDevelopment'
import production from './production'
import productQualityStrategy from './productQualityStrategy'
import rawMaterialsInventory from './rawMaterialsInventory'
import salesStrategy from './salesStrategy'
import scorePanel from './scorePanel'
import yearlyScorePanel from './yearlyScorePanel'
import step from './step'
import trainingIndex from './trainingIndex'
import investments from './investments'
import dashboard from './dashboard'
import participantQuiz from './participantQuiz'
import tutorial from './tutorials'
import tutor from './tutor'
import settings from './settings'

const rootReducer = combineReducers({
  accountsPayable,
  auth,
  balanceSheet,
  calculations,
  cashAlert,
  employees,
  otherCosts,
  dashboard,
  decisionAids,
  graphics,
  incomeStatements,
  intangibleAssets,
  investments,
  loans,
  marketForecast,
  marketingBoard,
  marketRound,
  marketStrategy,
  orders,
  participantQuiz,
  procurement,
  productDevelopment,
  production,
  scorePanel,
  yearlyScorePanel,
  productQualityStrategy,
  rawMaterialsInventory,
  salesStrategy,
  step,
  trainingIndex,
  user,
  tutorial,
  tutor,
  settings
})

export default rootReducer
